/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Factor } from './Factor';
import {
    FactorFromJSON,
    FactorFromJSONTyped,
    FactorToJSON,
    FactorToJSONTyped,
} from './Factor';

/**
 * 
 * @export
 * @interface AuthnContextUpdateChallengeOptions
 */
export interface AuthnContextUpdateChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof AuthnContextUpdateChallengeOptions
     */
    target_org_id: string;
    /**
     * 
     * @type {Factor}
     * @memberof AuthnContextUpdateChallengeOptions
     */
    factor?: Factor;
}

/**
 * Check if a given object implements the AuthnContextUpdateChallengeOptions interface.
 */
export function instanceOfAuthnContextUpdateChallengeOptions(value: object): value is AuthnContextUpdateChallengeOptions {
    if (!('target_org_id' in value) || value['target_org_id'] === undefined) return false;
    return true;
}

export function AuthnContextUpdateChallengeOptionsFromJSON(json: any): AuthnContextUpdateChallengeOptions {
    return AuthnContextUpdateChallengeOptionsFromJSONTyped(json, false);
}

export function AuthnContextUpdateChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthnContextUpdateChallengeOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'target_org_id': json['target_org_id'],
        'factor': json['factor'] == null ? undefined : FactorFromJSON(json['factor']),
    };
}

export function AuthnContextUpdateChallengeOptionsToJSON(json: any): AuthnContextUpdateChallengeOptions {
    return AuthnContextUpdateChallengeOptionsToJSONTyped(json, false);
}

export function AuthnContextUpdateChallengeOptionsToJSONTyped(value?: AuthnContextUpdateChallengeOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target_org_id': value['target_org_id'],
        'factor': FactorToJSON(value['factor']),
    };
}

